import { RpcService } from 'rpc';
export const svc = new RpcService({
    transport: 'WEBSOCKET',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `@@glossary.rpc`,
    services: {
        used_letters: {
            parameters: []
        },
        search_letter: {
            parameters: [
                {
                    name: 'search_char',
                    type: 'array',
                    optional: false
                }
            ]
        },
        search_text: {
            parameters: [
                {
                    name: 'search',
                    type: 'string',
                    optional: false
                }
            ]
        }
    }
});
export default svc;
